// import React, { useCallback } from 'react';
// import {
// 	View,
// 	Text,
// 	StyleSheet,
// 	TouchableOpacity,
// 	Image,
// 	Platform,
// } from 'react-native';
// // import { useLogin } from '../../../hooks/useLogin';
// import useLogin from '@hooks/useLogin/useLogin';
// import AuthenticationTextInput from '@components/atoms/AuthenticationTextInput';
// import ErrorMessage from '@components/atoms/ErrorMessage';

// function AuthScreen() {
// 	const {
// 		email,
// 		setEmail,
// 		password,
// 		setPassword,
// 		handleAuthentication,
// 		isLoading,
// 		error,
// 	} = useLogin();

// 	const checkPermissions = useCallback(async () => {
// 		if (Platform.OS === 'android') {
// 			try {
// 				// Dynamically import the Stripe Terminal module only on Android
// 				const {
// 					requestNeededAndroidPermissions,
// 				} = require('@stripe/stripe-terminal-react-native');

// 				const granted = await requestNeededAndroidPermissions({
// 					accessFineLocation: {
// 						title: 'Location Permission',
// 						message: 'Stripe Terminal needs access to your location',
// 						buttonPositive: 'Accept',
// 					},
// 				});

// 				if (granted) {
// 					console.log("Location permission granted, let's connect to a reader!");
// 					// Initialize or connect to Stripe Terminal here if needed
// 				} else {
// 					console.error(
// 						'Location and Bluetooth services are required to connect to a reader.'
// 					);
// 				}
// 			} catch (e) {
// 				console.error('Error requesting permissions:', e);
// 			}
// 		} else {
// 			// Optionally, handle web-specific logic here if necessary
// 			console.log(
// 				'Running on web or unsupported platform. Skipping Stripe Terminal setup.'
// 			);
// 		}
// 	}, []);

// 	const onSubmitHandler = async () => {
// 		const payload = {
// 			email,
// 			password,
// 		};

// 		await handleAuthentication('login', payload);
// 		await checkPermissions();
// 	};

// 	return (
// 		<View style={styles.background}>
// 			<Image
// 				style={styles.image}
// 				source={require('../../../assets/images/nmblogo.png')}
// 			/>
// 			<View style={styles.card}>
// 				<Text style={styles.heading}>Login</Text>
// 				<View style={styles.form}>
// 					<View style={styles.inputs}>
// 						<AuthenticationTextInput
// 							placeholder="Email"
// 							autoCapitalize="none"
// 							onChangeText={setEmail}
// 						/>
// 						<AuthenticationTextInput
// 							secureTextEntry
// 							placeholder="Password"
// 							onChangeText={setPassword}
// 						/>
// 						<TouchableOpacity style={styles.buttonAlt} onPress={onSubmitHandler}>
// 							<Text style={styles.buttonAltText}>Submit</Text>
// 						</TouchableOpacity>
// 					</View>
// 				</View>
// 				{error.length > 0 && <ErrorMessage message={error} />}
// 			</View>
// 		</View>
// 	);
// }

// const styles = StyleSheet.create({
// 	image: {
// 		marginTop: 50,
// 		width: 150,
// 		height: 150,
// 		resizeMode: 'contain',
// 	},
// 	background: {
// 		width: '100%',
// 		height: '100%',
// 		alignItems: 'center',
// 		overflow: 'auto',
// 		backgroundColor: 'rgba(11, 11, 69, 1)',
// 	},
// 	card: {
// 		width: '60%',
// 		borderRadius: 20,
// 		maxHeight: 380,
// 		paddingBottom: '20%',
// 	},
// 	heading: {
// 		fontSize: 30,
// 		fontWeight: 'bold',
// 		marginLeft: 'auto',
// 		marginRight: 'auto',
// 		marginTop: '5%',
// 		marginBottom: '15%',
// 		color: 'white',
// 	},
// 	form: {
// 		flex: 1,
// 		justifyContent: 'space-between',
// 		paddingBottom: '5%',
// 	},
// 	inputs: {
// 		width: '100%',
// 		flex: 1,
// 		alignItems: 'center',
// 		justifyContent: 'center',
// 		color: 'white',
// 	},
// 	buttonAlt: {
// 		marginTop: '5%',
// 		width: '80%',
// 		borderWidth: 1,
// 		height: 40,
// 		borderRadius: 50,
// 		borderColor: 'white',
// 		justifyContent: 'center',
// 		alignItems: 'center',
// 		marginVertical: 5,
// 	},
// 	buttonAltText: {
// 		color: 'white',
// 		fontSize: 16,
// 		fontWeight: 'bold',
// 	},
// });

// export default AuthScreen;

// AuthScreen.jsx

import React, { useCallback, useState } from 'react';
import {
	View,
	Text,
	StyleSheet,
	TouchableOpacity,
	Image,
	Platform,
	ActivityIndicator,
} from 'react-native';
import useLogin from '@hooks/useLogin/useLogin';
import AuthenticationTextInput from '@components/atoms/AuthenticationTextInput';
import ErrorMessage from '@components/atoms/ErrorMessage';

function AuthScreen() {
	const {
		email,
		setEmail,
		password,
		setPassword,
		handleAuthentication,
		isLoading,
		error,
		setError,
		setAuth,
	} = useLogin();

	const [step, setStep] = useState('login'); // 'login', '2fa-setup', '2fa-verify', 'done'
	const [qrCodeDataURL, setQrCodeDataURL] = useState('');
	const [twoFAToken, setTwoFAToken] = useState('');
	const [tempToken, setTempToken] = useState('');
	const [userId, setUserId] = useState('');

	const checkPermissions = useCallback(async () => {
		if (Platform.OS === 'android') {
			try {
				// Dynamically import the Stripe Terminal module only on Android
				const {
					requestNeededAndroidPermissions,
				} = require('@stripe/stripe-terminal-react-native');

				const granted = await requestNeededAndroidPermissions({
					accessFineLocation: {
						title: 'Location Permission',
						message: 'Stripe Terminal needs access to your location',
						buttonPositive: 'Accept',
					},
				});

				if (granted) {
					console.log("Location permission granted, let's connect to a reader!");
					// Initialize or connect to Stripe Terminal here if needed
				} else {
					console.error(
						'Location and Bluetooth services are required to connect to a reader.'
					);
				}
			} catch (e) {
				console.error('Error requesting permissions:', e);
			}
		} else {
			// Optionally, handle web-specific logic here if necessary
			console.log(
				'Running on web or unsupported platform. Skipping Stripe Terminal setup.'
			);
		}
	}, []);

	const onSubmitHandler = async () => {
		const payload = {
			email,
			password,
		};

		try {
			const response = await handleAuthentication('login', payload);

			if (response) {
				if (response.two_fa_setup_required) {
					// User needs to set up 2FA
					setQrCodeDataURL(response.qrCodeDataURL);
					setUserId(response.userId);
					setTempToken(response.tempToken);
					setStep('2fa-setup');
				} else if (response.two_fa_required) {
					// User needs to verify 2FA
					setTempToken(response.tempToken);
					setUserId(response.userId);
					setStep('2fa-verify');
				} else {
					// Regular login success
					setAuth(response.user);
					setStep('done');
				}
			}
		} catch (err) {
			setError(err.message || 'Login failed.');
		}

		await checkPermissions();
	};

	const verify2FAHandler = async () => {
		try {
			const response = await handleAuthentication('verify-2fa', {
				userId,
				token: twoFAToken,
				tempToken,
			});

			if (response) {
				setAuth(response.user);
				setStep('done');
			}
		} catch (err) {
			setError(err.message || 'Error verifying 2FA.');
		}
	};

	const setup2FAHandler = async () => {
		try {
			const response = await handleAuthentication('setup-2fa', {
				userId,
				token: twoFAToken,
				tempToken,
			});

			if (response) {
				setAuth(response.user);
				setStep('done');
			}
		} catch (err) {
			setError(err.message || 'Error setting up 2FA.');
		}
	};

	return (
		<View style={styles.background}>
			<Image
				style={styles.image}
				source={require('../../../assets/images/nmblogo.png')}
			/>
			<View style={styles.card}>
				{step === 'login' && (
					<>
						<Text style={styles.heading}>Login</Text>
						<View style={styles.form}>
							<View style={styles.inputs}>
								<AuthenticationTextInput
									placeholder="Email"
									autoCapitalize="none"
									onChangeText={setEmail}
									value={email}
								/>
								<AuthenticationTextInput
									secureTextEntry
									placeholder="Password"
									onChangeText={setPassword}
									value={password}
								/>
								<TouchableOpacity
									style={styles.buttonAlt}
									onPress={onSubmitHandler}
									disabled={isLoading}
								>
									{isLoading ? (
										<ActivityIndicator color="#fff" />
									) : (
										<Text style={styles.buttonAltText}>Submit</Text>
									)}
								</TouchableOpacity>
							</View>
						</View>
					</>
				)}

				{step === '2fa-setup' && (
					<View style={styles.twoFAContainer}>
						<Text style={styles.heading}>Set Up Two-Factor Authentication</Text>
						{qrCodeDataURL && (
							<Image style={styles.qrCode} source={{ uri: qrCodeDataURL }} />
						)}
						<Text style={styles.instructions}>
							Scan the QR code with your authenticator app, then enter the 6-digit code
							below.
						</Text>
						<AuthenticationTextInput
							placeholder="Enter the 6-digit code"
							onChangeText={setTwoFAToken}
							value={twoFAToken}
							keyboardType="numeric"
						/>
						<TouchableOpacity
							style={[
								styles.buttonAlt,
								{ opacity: twoFAToken.length === 0 ? 0.5 : 1 },
							]}
							onPress={setup2FAHandler}
							disabled={twoFAToken.length === 0 || isLoading}
						>
							{isLoading ? (
								<ActivityIndicator color="#fff" />
							) : (
								<Text style={styles.buttonAltText}>Verify 2FA Setup</Text>
							)}
						</TouchableOpacity>
					</View>
				)}

				{step === '2fa-verify' && (
					<View style={styles.twoFAContainer}>
						<Text style={styles.heading}>Enter Two-Factor Authentication Code</Text>
						<AuthenticationTextInput
							placeholder="Enter the 6-digit code"
							onChangeText={setTwoFAToken}
							value={twoFAToken}
							keyboardType="numeric"
						/>
						<TouchableOpacity
							style={[
								styles.buttonAlt,
								{ opacity: twoFAToken.length === 0 ? 0.5 : 1 },
							]}
							onPress={verify2FAHandler}
							disabled={twoFAToken.length === 0 || isLoading}
						>
							{isLoading ? (
								<ActivityIndicator color="#fff" />
							) : (
								<Text style={styles.buttonAltText}>Verify 2FA</Text>
							)}
						</TouchableOpacity>
					</View>
				)}

				{step === 'done' && (
					<View style={styles.successContainer}>
						<Text style={styles.successText}>Login successful!</Text>
						{/* Optionally, navigate to the home screen */}
					</View>
				)}

				{error.length > 0 && <ErrorMessage message={error} />}
			</View>
		</View>
	);
}

const styles = StyleSheet.create({
	image: {
		marginTop: 50,
		width: 150,
		height: 150,
		resizeMode: 'contain',
	},
	background: {
		width: '100%',
		height: '100%',
		alignItems: 'center',
		overflow: 'auto',
		backgroundColor: 'rgba(11, 11, 69, 1)',
	},
	card: {
		width: '60%',
		borderRadius: 20,
		maxHeight: 600, // Increased to accommodate 2FA steps
		paddingBottom: '20%',
		backgroundColor: '#0B0B45', // Added background color for better visibility
		padding: 20,
	},
	heading: {
		fontSize: 30,
		fontWeight: 'bold',
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: '5%',
		marginBottom: '15%',
		color: 'white',
		textAlign: 'center',
	},
	form: {
		flex: 1,
		justifyContent: 'space-between',
		paddingBottom: '5%',
	},
	inputs: {
		width: '100%',
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center',
		color: 'white',
	},
	buttonAlt: {
		marginTop: '5%',
		width: '80%',
		borderWidth: 1,
		height: 40,
		borderRadius: 50,
		borderColor: 'white',
		justifyContent: 'center',
		alignItems: 'center',
		marginVertical: 5,
		backgroundColor: '#0B0B45',
	},
	buttonAltText: {
		color: 'white',
		fontSize: 16,
		fontWeight: 'bold',
	},
	twoFAContainer: {
		alignItems: 'center',
		padding: 20,
	},
	qrCode: {
		width: 200,
		height: 200,
		marginBottom: 20,
	},
	instructions: {
		textAlign: 'center',
		marginBottom: 20,
		color: 'white',
	},
	successContainer: {
		alignItems: 'center',
		justifyContent: 'center',
		padding: 20,
	},
	successText: {
		fontSize: 18,
		color: 'green',
		textAlign: 'center',
	},
});

export default AuthScreen;
